import {useSignal, useSignals} from '@preact/signals-react/runtime'
import {InputText} from 'primereact/inputtext'
import {forwardRef, useImperativeHandle, useMemo} from 'react'

const StyledInput = forwardRef(
    (
        {
            key = '',
            value = null,
            placeholder = '',
            onChange = () => {},
            className = '',
            containerClassName = '',
            transformType = 'none',
            ...restProps
        },
        ref,
    ) => {
        useSignals()

        useImperativeHandle(ref, () => ({
            getValue: () => handleGetValue(),
            changeValue: newValue => handleChangeValue(newValue),
        }))

        const initialValue = useMemo(() => {
            return value || null
        }, [value])

        //#region Local State
        const selectedValue = useSignal(initialValue)

        const handleGetValue = () => {
            return selectedValue.peek()
        }

        const handleChangeValue = newValue => {
            selectedValue.value = newValue
        }
        //#endregion

        return (
            <div id="styled-input-text" className={`${containerClassName}`}>
                <InputText
                    className={`w-full h-3rem ${className}`}
                    style={{fontSize: '14px'}}
                    value={selectedValue?.value || ''}
                    onChange={e => {
                        let newValue = e.target.value

                        if (transformType === 'lowercase') {
                            newValue = newValue.toLowerCase()
                        }

                        if (onChange) {
                            onChange(newValue)
                        }

                        selectedValue.value = newValue
                    }}
                    placeholder={placeholder}
                    {...restProps}
                />
            </div>
        )
    },
)

export default StyledInput
